export default __webpack_public_path__ + "static/desktop_menu_KV17-aca29903d64682c4095092735a516654.mp4";